import { Loader2 } from "lucide-react"
import { cn } from "@/lib/utils"

interface LoadingSpinnerProps {
  className?: string
  /** Volle Hoehe zentriert (Seiten-Fallback) */
  fullPage?: boolean
}

export function LoadingSpinner({ className, fullPage = false }: LoadingSpinnerProps) {
  const spinner = (
    <Loader2 className={cn("h-8 w-8 animate-spin text-muted-foreground", className)} />
  )
  if (fullPage) {
    return <div className="flex h-96 items-center justify-center">{spinner}</div>
  }
  return spinner
}
